import { createFileRoute } from '@tanstack/react-router';
import { useStore } from '@tanstack/react-store';
import { useState } from 'react';
import { PageSection } from '~/routes/__root';
import { langStore } from '~/store/langStore';
import { MarkdownBlock } from '~/utils/markdown';

export const Route = createFileRoute('/privacy')({
  component: Privacy,
});

const privacyContent = {
  HU: `# Adatvédelmi Nyilatkozat

## Analitika
A weboldalunk az Umami analitikát használja a látogatók viselkedésének megértéséhez. Ez a rendszer:
- Nem használ sütiket
- Nem gyűjt személyes adatokat
- Nem oszt meg adatokat harmadik felekkel
- Helyileg tárolja az adatokat
- Anonimizálja az adatokat

## Adatkezelés
Az adatkezelés jogalapja a weboldal működésének biztosítása és a felhasználói élmény javítása. Az adatokat kizárólag ezekre a célokra használjuk.

## Kapcsolat
Kérdéseivel kapcsolatban keressen minket a kapcsolati oldalon.`,

  EN: `# Privacy Policy

## Analytics
Our website uses Umami analytics to understand visitor behavior. This system:
- Does not use cookies
- Does not collect personal data
- Does not share data with third parties
- Stores data locally
- Anonymizes data

## Data Processing
The legal basis for data processing is ensuring the operation of the website and improving user experience. We only use the data for these purposes.

## Contact
For any questions, please contact us through our contact page.`,

  RS: `# Politika privatnosti

## Analitika
Naša veb stranica koristi Umami analitiku za razumevanje ponašanja posetilaca. Ovaj sistem:
- Ne koristi kolačiće
- Ne prikuplja lične podatke
- Ne deli podatke sa trećim stranama
- Čuva podatke lokalno
- Anonimizira podatke

## Obrada podataka
Pravna osnova za obradu podataka je osiguravanje funkcionisanja veb stranice i poboljšanje korisničkog iskustva. Podatke koristimo samo u te svrhe.

## Kontakt
Za sva pitanja, molimo kontaktirajte nas putem naše kontakt stranice.`,
};

function DoNotTrackButton() {
  const locale = useStore(langStore, s => s);
  const [isDisabled, setIsDisabled] = useState(() => {
    if (typeof window === 'undefined')
      return false;
    return localStorage.getItem('umami.disabled') === 'true';
  });

  const buttonText = {
    HU: {
      enable: 'Analitika bekapcsolása',
      disable: 'Analitika kikapcsolása',
    },
    EN: {
      enable: 'Enable Analytics',
      disable: 'Disable Analytics',
    },
    RS: {
      enable: 'Uključi analitiku',
      disable: 'Isključi analitiku',
    },
  };

  const handleClick = () => {
    if (typeof window === 'undefined')
      return;

    if (isDisabled) {
      localStorage.removeItem('umami.disabled');
    }
    else {
      localStorage.setItem('umami.disabled', 'true');
    }
    setIsDisabled(!isDisabled);
    window.location.reload();
  };

  return (
    <button
      onClick={handleClick}
      className="mt-4 rounded bg-orange px-4 py-2 text-white transition-colors hover:bg-orange/80"
      data-umami-event={isDisabled ? 'enable-analytics' : 'disable-analytics'}
      type="button"
    >
      {isDisabled ? buttonText[locale].enable : buttonText[locale].disable}
    </button>
  );
}

function Privacy() {
  const locale = useStore(langStore, s => s);

  return (
    <PageSection width="narrow">
      <MarkdownBlock>
        {privacyContent[locale]}
      </MarkdownBlock>
      <div className="flex justify-center">
        <DoNotTrackButton />
      </div>
    </PageSection>
  );
}
